<form [formGroup]="form" class="profile-address__wrapper" (submit)="onSubmit()">
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">Address Line 1</label>
        <input
          type="text"
          class="lum-input"
          formControlName="shipping_address"
          placeholder="Address Line 1"
        />
        <mat-error
          *ngIf="shippingAddressControl && shippingAddressControl.invalid"
          >{{ shippingAddressControl | validateField }}</mat-error
        >
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="">Address Line 2</label>
        <input
          type="text"
          class="lum-input"
          formControlName="shipping_address_line_2"
          placeholder="Address Line 2"
        />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">State</label>
        <input
          type="text"
          class="lum-input"
          formControlName="shipping_state"
          placeholder="State"
        />
        <mat-error *ngIf="shippingStateControl && shippingStateControl.invalid">{{
          shippingStateControl | validateField
        }}</mat-error>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="">City</label>
        <input
          type="text"
          class="lum-input"
          formControlName="shipping_city"
          placeholder="City"
        />
        <mat-error *ngIf="shippingCityControl && shippingCityControl.invalid">{{
          shippingCityControl | validateField
        }}</mat-error>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="form-group">
        <label for="">Zip Code</label>
        <input
          type="text"
          class="lum-input"
          formControlName="shipping_zip"
          placeholder="Zip Code"
        />
        <mat-error *ngIf="shippingZipControl.invalid">{{
          shippingZipControl | validateField
        }}</mat-error>
      </div>
    </div>
    <div class="col-6">
      <div class="form-group">
        <label for="">Country</label>
        <mat-select formControlName="shipping_country" class="lum-select">
          <mat-option *ngFor="let country of countryList" [value]="country.value">
            {{ country.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="shippingCountryControl.invalid">{{
          shippingCountryControl | validateField
        }}</mat-error>
      </div>
    </div>
  </div>
  <div class="lum-modal__footer mt-4 w-p100" mat-dialog-actions>
    <div class="flex ml-auto lum-modal__action">
      <button
        type="button"
        class="lum-button lum-button--secondary mr-2"
        mat-button
        (click)="onChangeTab()"
      >
        <lum-ui-icon
          icon="chevron-left"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Previous
      </button>

      <button type="submit" [disabled]="hasInvalidInput" class="lum-button">
        <ng-container *ngIf="!(loading$ | async); else loader">
          Save
          <lum-ui-icon
            class="ml-2-5"
            icon="content-save"
            color="#ffffff"
            width="23"
            height="23"
          ></lum-ui-icon>
        </ng-container>
        <ng-template #loader>
          <mat-progress-spinner
            class="progress-spinner"
            diameter="23"
            mode="indeterminate"
          ></mat-progress-spinner>
        </ng-template>
      </button>
    </div>
  </div>
</form>
